import {Component, Input, OnInit} from "@angular/core";

@Component({
  selector: 'app-hippa-pdf',
  templateUrl: './hippa-pdf.component.html',
  styleUrls: ['./hippa-pdf.component.scss']
})
export class HippaPdfComponent implements OnInit {
  @Input() url: string;
  @Input() zoom = 1;
  constructor() { }

  ngOnInit() {
  }
  
  incrementZoom(amount: number) {
    this.zoom += amount;   
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/hippa-pdf/hippa-pdf.component.ts